import { INSTRUMENT_SECTIONS } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import InstrumentSectionPage from "./container/InstrumentSectionPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: INSTRUMENT_SECTIONS,
    withSidebar: true,
    withAppBar: true,
    component: InstrumentSectionPage,
  };
}
